import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule, MatFormFieldModule, MatInputModule} from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { AppComponent } from './app.component';
import { InvestFundMaisRetornoComponent } from './invest-fund-mais-retorno/invest-fund-mais-retorno.component';
import { InvestFundSunoComponent } from './invest-fund-suno/invest-fund-suno.component';
import { InvestFundOldComponent } from './invest-fund-old/invest-fund-old.component';

const appRoutes: Routes = [
  { path: 'invest-fund-mais-retorno', component: InvestFundMaisRetornoComponent },
  { path: 'invest-fund-suno', component: InvestFundSunoComponent },
  { path: 'invest-fund-suno', component: InvestFundOldComponent },
  { path: '**', component: InvestFundMaisRetornoComponent }
];

@NgModule({
  declarations: [
    AppComponent,
    InvestFundMaisRetornoComponent,
    InvestFundOldComponent,
    InvestFundSunoComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgbModule,
    MatAutocompleteModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    CurrencyMaskModule,
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: false }
    )
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
